import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import Header from "../Header";
import { ProductContext } from "../../context/AppContext";
import { SocketContext } from "../../context/socketContext";
import { all_routes } from "../router/all_routes";

const Notification = () => {
  const navigate = useNavigate();
  const routes = all_routes;
  const { getNotification = [] } = useContext(ProductContext) || {};
  const { notificationlist = [] } = useContext(SocketContext) || {};

  const moduleCatalog = [
    { id: 1, label: "MAIN" },
    { id: 2, label: "Enquiry" },
    { id: 3, label: "Visitor" },
    { id: 4, label: "Masters" },
    { id: 5, label: "Staff" },
    { id: 6, label: "Student Information" },
    { id: 7, label: "Time Table" },
    { id: 8, label: "Communication" },
    { id: 9, label: "Transport" },
    { id: 10, label: "Academic" },
    { id: 11, label: "MANAGEMENT" },
    { id: 12, label: "HRM" },
    { id: 13, label: "SMS" },
    { id: 14, label: "Manage Role Menu" },
    { id: 15, label: "Library" },
    { id: 16, label: "Entrance Exam Booking" },
    { id: 21, label: "Entrance Reexam" },
    { id: 23, label: "Entrance Reshedule" },
  ];

  const modules = useMemo(() => {
    const sourceNotifications = [...(getNotification || []), ...(notificationlist || [])];

    const countsByModule = sourceNotifications.reduce((acc, notification) => {
      const moduleKey =
        notification?.module_id ??
        notification?.moduleId ??
        notification?.module ??
        notification?.module_name;

      if (moduleKey === undefined || moduleKey === null) {
        return acc;
      }

      const normalizedKey = Number.isNaN(Number(moduleKey)) ? moduleKey : Number(moduleKey);
      acc[normalizedKey] = (acc[normalizedKey] || 0) + 1;
      return acc;
    }, {});

    return moduleCatalog
      .map((module) => ({
        ...module,
        count: countsByModule[module.id] || countsByModule[module.label] || 0,
      }));
  }, [getNotification, notificationlist]);

  const handleModuleClick = (moduleId) => {
    navigate(`${routes.notificationModuleWise}/${moduleId}`);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <Header />
        <Container fluid className="py-4">
          <h3 className="page-title mb-4">
            <i className="fas fa-bell me-2"></i>Notifications
          </h3>
          <Row>
            {modules.length > 0 ? (
              modules.map((module) => (
                <Col md={4} sm={6} key={module.id} className="mb-4">
                  <Card
                    className="shadow-sm border-0 h-100"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleModuleClick(module.id)}
                  >
                    <Card.Body className="position-relative">
                      <Badge
                        pill
                        bg="danger"
                        className="position-absolute top-0 end-0 translate-middle"
                        style={{
                          fontSize: "0.6rem",
                          padding: "0.25rem 0.4rem",
                          transform: "translate(50%, -50%)",
                        }}
                      >
                        {module.count}
                      </Badge>
                      <div className="d-flex align-items-center justify-content-between">
                        <h5 className="card-title mb-0">{module.label}</h5>
                        <i className="fas fa-chevron-right text-muted"></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <Card className="shadow-sm border-0">
                  <Card.Body className="text-center py-5">
                    <i className="ti ti-bell-off fs-1 text-muted d-block mb-3"></i>
                    <h5 className="mb-2">No modules found</h5>
                    <p className="mb-0 text-muted">
                      No notifications are available yet.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Notification;
